import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { MessagesAnalyticsPageStore } from 'pages/analytics/pages/messages/store/messagesAnalyticsPageStore'

const MessagesAnalyticsPageContext = createContext<MessagesAnalyticsPageStore | null>(null)

export const useMessagesAnalyticsPageContext = () => {
  const context = useContext(MessagesAnalyticsPageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with MessagesAnalyticsPageProvider'
    )

  return context
}

export const MessagesAnalyticsPageProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new MessagesAnalyticsPageStore(entities), [])

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <MessagesAnalyticsPageContext.Provider value={store}>
      {children}
    </MessagesAnalyticsPageContext.Provider>
  )
}
